import TypeBadge from './TypeBadge'

export default TypeBadge
